const scale = 1.25;

export default class Obstacle extends Phaser.Group {
  constructor({ game, type }) {
    super(game);

    this.type = type;
    this.costume = this.game.make.image(0, -30, 'obstacles', 'obstacle_' + type);
    this.costume.anchor.set(0.5);
    this.costume.scale.set(scale);
    this.addChild(this.costume);
  }

  getWorldBounds() {
    const bounds = this.costume.getBounds();
    let bw = bounds.width * scale;
    bw = bw * 0.95;
    bounds.x += bw * 0.025;

    bounds.x += this.game.camera.view.x;
    bounds.y += this.game.camera.view.y;

    return bounds;
  }
}
